<template>
  <div :class="['sheep-wrapper', isWeChat ? 'wechat' : '', isIos ? 'ios' : '', isHarmony ? 'harmony' : '']">
    <!-- 活动标题 -->
    <div v-wechat-title="'《魔卡少女樱》x《喜羊羊》联动活动开启'"></div>

    <Header :isOnline="1" :config="headerConfig" :isShowInfo="true" :isShowDownLoad="true" @onDownload="handleDownloadClick" />

    <div class="content-swiper-container swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <!-- 第一页 -->
          <div class="first-box">
            <div class="first-contaienr">
              <div class="share-btns">
                <div class="share-btn-icon btn-weibo" @click="shareClick(1)"></div>
                <!-- <div class="share-btn-icon btn-wechat" @click="shareClick(2)"></div> -->
                <div class="share-btn-icon btn-taptap" @click="shareClick(3)"></div>
                <div class="share-btn-icon btn-douyin" @click="shareClick(4)"></div>
              </div>
              <div :class="['kefu-code', showKefuCode ? '' : 'kefu-hide']">
                <img class="img-kefu-code" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/kefu_code.png" />
                <div class="btn-Change-show" @click="handleChangeKefu"></div>
              </div>
              <div class="top-title"></div>
              <div class="xiyangyang"></div>
              <div class="xiaoying"></div>
              <div class="left-zhuzi"></div>
              <div class="right-zhuzi"></div>
              <div class="bottom-box">
                <div class="inc"></div>
              </div>
              <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
                <div v-show="titleShow" class="bottom-title">
                  <div class="btn-play-video" @click="handleVideoPlay"></div>
                </div>
              </transition>
              <div class="btn-next-text" @click="goNextSwiper(1)"></div>
              <div class="btn-next" @click="goNextSwiper(1)"></div>
            </div>
          </div>
        </div>
        <div class="swiper-slide silde-2">
          <!-- 第二页 -->
          <div class="sec-container">
            <div class="top-box"></div>
            <div class="btn-rule" @click="handleShowRuleDetail"></div>
            <div class="table-box">
              <div :class='["basket-box",opened ? "opened" : ""]'></div>
              <div class="btn-exchange" @click="handleShowAllReward"></div>
              <div class="btn-share" @click="handleShareFriend"></div>
              <div class="roll-container">
                <div class="roll-num">
                  剩余次数：<span>{{activeInfo.times || 0}}</span>
                </div>
                <div class="btn-roll" @click="draw"></div>
              </div>
            </div>
            <div class="bottom-box"></div>
            <div class="title-box">
              <!-- <div class="btn-tip" @click="handleSignRuleDetail"></div>
               -->
            </div>
            <div class="days-box">
              <div v-for="(item, idx) of days" :key="idx" class="item">
                <div :class="['top', sign_day > idx ? 'signed' : (sign_day === idx && !sigin_status ? 'can-sign' : 'no-sign')]">
                  {{ item }}
                </div>
                <div :class="['bottom', `bottom-${idx}`]">
                  <div v-if="sign_day > idx" class="signed" />
                  <div v-if="sign_day === idx && !sigin_status" class="can-sign" @click="handleSign">
                    <img class="img-wave" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/img_wave.png" />
                  </div>
                  <div class="no-sign" />
                </div>
              </div>
            </div>
            <div class="btn-next" @click="goNextSwiper(2)"></div>
          </div>
        </div>
        <div class="swiper-slide slide-3">
          <!-- 第三页 -->
          <div class="third-container">
            <div class="title"></div>
            <div class="third-content-box">
              <div class="play-way-content-box">
                <div class="play-way-swiper-container swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide slide1">
                      <div class="info-img-box"></div>
                    </div>
                    <div class="swiper-slide slide2">
                      <div class="info-img-box"></div>
                    </div>
                    <div class="swiper-slide slide3">
                      <div class="info-img-box"></div>
                    </div>
                    <div class="swiper-slide slide4">
                      <div class="info-img-box"></div>
                    </div>
                    <div class="swiper-slide slide5">
                      <div class="info-img-box"></div>
                    </div>
                  </div>
                  <div class="swiper-pagination play-way-pagination">
                    <div class="bg"></div>
                  </div>
                </div>
              </div>
              <div class="china-jie"></div>
            </div>
            <div class="btn-go-back" @click="goNextSwiper(1)"></div>
            <div class="reward-show-box">
              <div class="go-weibo" @click="handleEnterWeibo"></div>
            </div>
            <div class="btn-next" @click="goNextSwiper(3)"></div>
          </div>
        </div>
        <div class="swiper-slide">
          <!-- 第四页 -->
          <div class="fouth-container">
            <div :class="['title', `title-${currentRoleIndex}`]"></div>
            <div :class="['btn-one', 'show']" @click="handleChangeRole(0)"></div>
            <div :class="['btn-two', showNumber2 ? 'show': '']" @click="handleChangeRole(1)"></div>
            <div class="to-be-waited" v-if="!showNumber2"></div>
            <div class="dance-box">
              <div class="bg-dance"></div>
              <div :class="['roles-pool-box', currentRoleIndex === 0 ? 'show': '']">
                <div class="roles-img-box">
                  <div :class="['role_intro_item', 'role_intro_1', currentRoles1Index === 0 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role1.png">
                    <span class="star_6"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_2', currentRoles1Index === 1 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role2.png">
                    <span class="star_5"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_3', currentRoles1Index === 2 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role3.png">
                    <span class="star_4"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_4', currentRoles1Index === 3 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role4.png">
                    <span class="star_4"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_5', currentRoles1Index === 4 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role5.png">
                    <span class="star_3"></span>
                  </div>
                </div>
                <div class="roles-swiper-box">
                  <div class="roles-swiper-container swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_1.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_1_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_2.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_2_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_3.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_3_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_4.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_4_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_5.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_5_active.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="['roles-pool-box', currentRoleIndex === 1 ? 'show': '']">
                <div class="roles-img-box">
                  <div :class="['role_intro_item', 'role_intro_6', currentRoles2Index === 0 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role6.png">
                    <span class="star_6"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_7', currentRoles2Index === 1 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role7.png">
                    <span class="star_5"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_8', currentRoles2Index === 2 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role8.png">
                    <span class="star_4"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_9', currentRoles2Index === 3 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role9.png">
                    <span class="star_4"></span>
                  </div>
                  <div :class="['role_intro_item', 'role_intro_10', currentRoles2Index === 4 ? 'show' : '']">
                    <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role10.png">
                    <span class="star_3"></span>
                  </div>
                </div>
                <div class="roles-swiper-box">
                  <div class="roles-swiper-container1  swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_6.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_6_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_7.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_7_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_8.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_8_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_9.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_9_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_10.png" />
                        <img class="img_active" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/roles/role_icon_10_active.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn-go-back" @click="goNextSwiper(1)"></div>
            <div class="btn-next" @click="goNextSwiper(4)"></div>
          </div>
        </div>
        <div class="swiper-slide slide-5">
          <!-- 第五页 -->
          <div class="five-container">
            <div class="game-content-box">
              <div class="title"></div>
              <div class="btn-go-back" @click="goNextSwiper(1)"></div>
              <div class="swiper-box">
                <div class="game-swiper-container swiper-no-swiping swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide slide1">
                      <div class="info-img-box">
                        <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/game1.png" alt="">
                      </div>
                    </div>
                    <div class="swiper-slide slide2">
                      <div class="info-img-box">
                        <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/game2.png" alt="">
                      </div>
                    </div>
                    <div class="swiper-slide slide3">
                      <div class="info-img-box">
                        <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/game3.png" alt="">
                      </div>
                    </div>
                    <div class="swiper-slide slide4">
                      <div class="info-img-box">
                        <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/game4.png" alt="">
                      </div>
                    </div>
                    <div class="swiper-slide slide5">
                      <div class="info-img-box">
                        <img src="https://download4.qcplay.com/h5-images/active/sakura/sheep/game5.png" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination game-pagination">
                  </div>
                </div>
                <div class="swiper-button-prev game-button-prev"></div>
                <div class="swiper-button-next game-button-next"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide slide-footer">
          <Footer :gameName="gameName"></Footer>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :downloadUrl="downloadUrl" :loginTypes="loginTypes"></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <!-- 登记信息弹窗 -->
    <div class="address-wrap popup_wrap" v-show="isShowAddress">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="address-box popup_wrap-box" v-show="isShowAddress">
          <div class="award-form">
            <p class="recipients">
              <input placeholder="请输入姓名" v-model="name" @focus="inputFocus()" @focusout="inputFocusOut" />
            </p>
            <p class="phone">
              <input placeholder="请输入手机号" v-model="phone" @focus="inputFocus()" @focusout="inputFocusOut" />
            </p>
            <p class="address">
              <input placeholder="请输入地址" v-model="address" @focus="inputFocus()" @focusout="inputFocusOut" />
            </p>
          </div>
          <div class="btn-confirm" @click="submitInfo"></div>
          <div class="btn-close" @click="closeAddress"></div>
        </div>
      </transition>
    </div>

    <!-- 地址填写成功弹窗 -->
    <div class="address-success-wrap popup_wrap" v-show="addressSuccess">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="address-success-box" v-show="addressSuccess">
          <div class="btn-close" @click="addressSuccess = false"></div>
          <div class="btn-cancel" @click="addressSuccess = false"></div>
        </div>
      </transition>
    </div>

    <!-- 活动规则弹窗 -->
    <div class="rules-wrap popup_wrap" v-show="isShowRules">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="rules-box popup_wrap-box" v-show="isShowRules">
          <div class="close" @click="isShowRules = false"></div>
          <div class="close-bg" @click="isShowRules = false"></div>
        </div>
      </transition>
    </div>
    <!-- 签到规则弹窗 -->
    <div class="sign-rules-wrap popup_wrap" v-show="showSignDetail">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="sign-rules-box" v-show="showSignDetail">
          <div class="close" @click="showSignDetail = false"></div>
          <div class="close-bg" @click="showSignDetail = false"></div>
        </div>
      </transition>
    </div>
    <!-- 签文奖励汇总弹窗 -->
    <div class="all-reward-wrap popup_wrap" v-show="showAllReward">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="all-reward-box" v-show="showAllReward" @click.stop="">
          <div class="china-tie"></div>
          <div v-show="currentIndex === 0">
            <div class="reward-exchange-box">
              <div class="reward-item reward1">
                <div class="btn-exchange" @click="handleExchange(1)"></div>
              </div>
              <div class="reward-item reward2">
                <div class="btn-exchange show-write" v-if="activeInfo.matter_list && activeInfo.matter_list.find((item) => item.exchange_id === 2) && !activeInfo.phone" @click="handleWriteAddress"></div>
                <div class="btn-exchange" v-else @click="handleExchange(2)"></div>
              </div>
              <div class="reward-item reward3">
                <div class="btn-exchange show-write" v-if="activeInfo.matter_list && activeInfo.matter_list.find((item) => item.exchange_id === 3) && !activeInfo.phone" @click="handleWriteAddress"></div>
                <div class="btn-exchange" v-else @click="handleExchange(3)"></div>
              </div>
            </div>
            <div class="tags-box">
              <div v-for="(item, idx) of tags" :key="idx" :class="['item', `item-${idx}`]">
                <div :class="['top', sign_day > idx ? 'signed' : (sign_day === idx && !sigin_status ? 'can-sign' : 'no-sign')]">
                  {{ item }}
                </div>
                <div class="bottom">
                  <div class="no-sign" />
                </div>
              </div>
            </div>
          </div>
          <div v-show="currentIndex === 1">
            <div class="stuff-box">
              <div class="title">实物奖励</div>
              <div class="content">{{ activeInfo.matter_list && activeInfo.matter_list.length ? activeInfo.matter_list.map((i) => i.prop_name).join(',') : '暂未兑换过实物奖励' }}</div>
            </div>
            <div class="game-stuff-box">
              <div class="title">游戏道具奖励</div>
              <div class="content-box">
                <div v-for="(item, idx) of (activeInfo.character_reward || [])" :key="idx" class="item">
                  <span :class="['reward-name', item.status === 1 ? 'got' : '']">{{ item.prop_name }}</span>
                </div>
              </div>
            </div>
            <div @click="handleGetAll" class="btn-get-all"></div>
          </div>
          <div class="btn-tags" @click="currentIndex = 0"></div>
          <div class="btn-myReward" @click="currentIndex = 1"></div>
          <div class="btn-close" @click="showAllReward = false"></div>
          <div class="close-bg" @click="showAllReward = false"></div>
        </div>
      </transition>
    </div>
    <!-- 兑换奖励二次确认弹窗 -->
    <div class="exchange-confirm-wrap popup_wrap" v-show="showExchangeConfirm">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="exchange-confirm-box" v-show="showExchangeConfirm">
          <div class="text">是否消耗{{ tagsText[sign_id || 1] }}兑换奖品</div>
          <div class="btn-confirm" @click="handleExchangeConfirm"></div>
          <div class="btn-cancel" @click="showExchangeConfirm = false"></div>
          <div class="btn-close" @click="showExchangeConfirm = false"></div>
        </div>
      </transition>
    </div>
    <!-- 兑换奖励成功 -->
    <div class="exchange-success-wrap popup_wrap" v-show="showExchangeSuccess">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="exchange-success-box" v-show="showExchangeSuccess">
          <div class="btn-confirm" @click="showExchangeSuccess = false"></div>
          <div class="btn-cancel" @click="showExchangeSuccess = false"></div>
          <div class="btn-close" @click="showExchangeSuccess = false"></div>
        </div>
      </transition>
    </div>
    <!-- 签文不足 -->
    <div class="noSigns-wrap popup_wrap" v-show="showNoSigns">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="noSigns-box" v-show="showNoSigns">
          <div class="btn-confirm" @click="showNoSigns = false"></div>
          <div class="btn-cancel" @click="showNoSigns = false"></div>
          <div class="btn-close" @click="showNoSigns = false"></div>
        </div>
      </transition>
    </div>
    <!-- 领取成功弹窗 -->
    <div class="get-success-wrap popup_wrap" v-show="showGetSuccess">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="get-success-box" v-show="showGetSuccess">
          <div class="btn-confirm" @click="showGetSuccess = false"></div>
          <div class="btn-cancel" @click="showGetSuccess = false"></div>
          <div class="btn-close" @click="showGetSuccess = false"></div>
        </div>
      </transition>
    </div>
    <!-- 分享弹窗 -->
    <div class="share-friend-wrap popup_wrap" v-show="showShare">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="share-friend-box" v-show="showShare">
          <div class="text">{{ shareLink }}</div>
          <div class="btn-copy" @click="onCopy('#clipboard-btn')" id="clipboard-btn" data-event="复制邀请链接" :data-clipboard-text="shareText + shareLink"></div>
          <div class="btn-close" @click="showShare = false"></div>
          <div class="close-bg" @click="showShare = false"></div>
        </div>
      </transition>
    </div>
    <!-- 抽签结果弹窗 -->
    <div :class="['draw-result-wrap', 'popup_wrap', `reward-${reward_id}`]" v-show="showDrawResult">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="draw-result-box" v-show="showDrawResult">
          <div :class="['flip-card', flip === 'font' ? '' : 'is-flipped']">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img v-show="reward_id === 1" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_baofu.png" alt="">
                <img v-show="reward_id === 2" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_taohua.png" alt="">
                <img v-show="reward_id === 3" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_xueye.png" alt="">
                <img v-show="reward_id === 4" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_shengzhi.png" alt="">
                <img v-show="reward_id === 5" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_jiankang.png" alt="">
                <img v-show="reward_id === 6" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_tebie.png" alt="">
                <div class="text-old">{{ oldYear }}</div>
                <div class="text-new">{{ newYear }}</div>
                <div class="btn-flip" @click="handleFlip('back')"></div>
                <div class="btn-share" @click="handleShareClick"></div>
                <div class="btn-cancel" @click="handleCloseDrawResult"></div>
                <div class="btn-close" @click="handleCloseDrawResult"></div>
              </div>
              <div class="flip-card-back">
                <img v-show="reward_id === 1" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_baofu_back.png" alt="" />
                <img v-show="reward_id === 2" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_taohua_back.png" alt="" />
                <img v-show="reward_id === 3" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_xueye_back.png" alt="" />
                <img v-show="reward_id === 4" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_shengzhi_back.png" alt="" />
                <img v-show="reward_id === 5" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_jiankang_back.png" alt="" />
                <img v-show="reward_id === 6" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_draw_tebie_back.png" alt="" />
                <div class="btn-flip" @click="handleFlip('font')"></div>
                <div class="btn-share" @click="handleShareClick"></div>
                <div class="btn-cancel" @click="handleCloseDrawResult"></div>
                <div class="btn-close" @click="handleCloseDrawResult"></div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 解签弹窗 -->
    <div class="break-draw-wrap popup_wrap" v-show="showBreakDraw">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="break-draw-box" v-show="showBreakDraw">
          <div :class="['img-label', `label-${reward_id}`]"></div>
          <div class="btn-close">
            <div class="btn-break" @click="handleBreakDraw"></div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 视频播放弹窗 -->
    <div class="video-wrap popup_wrap" v-show="showVideo">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div>
          <div class="video-box" v-show="showVideo">
            <video id="player" ref="videoPlayer" src="https://download4.qcplay.com/qcgame-admin/VjUvdRPCqOA1suiiCPTzzczERSe70MqA9tgeWANt.mp4" webkit-playsinline='true' playsinline='true' preload="auto" x5-video-player-type="h5-page" x-webkit-airplay="true" x5-video-player-fullscreen="true" x5-video-ignore-metadata="true" controlslist="nodownload nofullscreen" poster="" @click="pauseVideo">
            </video>
            <img v-show="!isPlay" @click="pauseVideo" class="btn-start" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/btn_play.png" />
          </div>
          <img @click="handleCloseVideo" class="btn-close" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/btn_close_video.png" />
        </div>
      </transition>
    </div>
    <!-- 公众号弹窗 -->
    <div class="wechat-wrap popup_wrap" v-show="showWechat">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="wechat-box" v-show="showWechat">
          <img class="img-wechat" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/img_wechat.png" />
          <div class="btn-close" @click="showWechat = false"></div>
          <div class="close-bg" @click="showWechat = false"></div>
        </div>
      </transition>
    </div>
    <!-- 抽中道具弹窗 -->
    <div class="draw-result-game-staff-wrap popup_wrap" v-show="showGameStaff">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="draw-result-game-staff-box" v-show="showGameStaff">
          <div class="title">恭喜您获得：{{reward_name}}</div>
          <div class="btn-confirm" @click="showGameStaff = false"></div>
          <div class="btn-cancel" @click="showGameStaff = false"></div>
          <div class="btn-close" @click="showGameStaff = false"></div>
        </div>
      </transition>
    </div>
    <!-- 分享相关dom -->
    <div class="share-box-sheep" ref="imageDom">
      <img class="bg-share" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_image.png" />
      <div class="content-box">
        <div class="text-old">{{ oldYear }}</div>
        <div class="text-new">{{ newYear }}</div>
        <!-- <div :class="['img-tag', `reward-${reward_id}`]"></div> -->
        <img v-show="reward_id === 1" class="img-tag reward-1" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_baofu.png" alt="">
        <img v-show="reward_id === 2" class="img-tag reward-2" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_taohua.png" alt="">
        <img v-show="reward_id === 3" class="img-tag reward-3" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_xueye.png" alt="">
        <img v-show="reward_id === 4" class="img-tag reward-4" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_shengzhi.png" alt="">
        <img v-show="reward_id === 5" class="img-tag reward-5" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_jiankang.png" alt="">
        <img v-show="reward_id === 6" class="img-tag reward-6" src="https://download4.qcplay.com/h5-images/active/sakura/sheep/bg_save_tebie.png" alt="">
      </div>
    </div>
    <!-- 保存图片弹窗 -->
    <div class="save-image-wrap popup_wrap" v-show="saveShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="save-image-box popup_wrap-box" v-show="saveShow">
          <img :src="shareImg" alt="分享图片" />
          <div class="btn-close" @click="handleCloseSaveModal"></div>
          <div class="close-bg" v-show="saveShow" @click="handleCloseSaveModal"></div>
        </div>
      </transition>
    </div>
    <!-- 授权弹窗 -->
    <div class="auth-wrap popup_wrap" v-show="showAuth">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="auth-box popup_wrap-box" v-show="showAuth">
          <div class="btn-auth">手机摇一摇需要获取您的陀螺仪权限~</div>
          <div class="btn-confirm" @click="getAuth"></div>
          <div class="btn-cancel" @click="showAuth = false"></div>
          <div class="btn-close" @click="showAuth = false"></div>
        </div>
      </transition>
    </div>
    <!-- 晃动弹窗 -->
    <div class="shake-tip-wrap popup_wrap" v-show="showShakeTip">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="shake-tip-box popup_wrap-box" v-show="showShakeTip">
          <div class="btn-cancel" @click="handleCloseShakeTip"></div>
          <div class="btn-close" @click="handleCloseShakeTip"></div>
        </div>
      </transition>
    </div>
    <!-- 微信外部引导 -->
    <div class="wechat-out-wrap popup_wrap" v-show="showInWechat" @click="showInWechat = false">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="wechat-out-box popup_wrap-box" v-show="showInWechat">
        </div>
      </transition>
    </div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import Clipboard from "clipboard";
import Swiper from 'swiper'
import "swiper/dist/css/swiper.css"
import { onGetInitDataAPI, onSubmitAddress, onSign, onGetRewardOnBag, onDraw, onGetReward, onHelp, secretFreeLoginApi } from "../api";
import { buriedLogger, getRandomString, wechatBrowser, analysisParams } from "@/utils/utils";
import { generateCanvasImage } from '@/utils/share';
import calendarFormatter from '../lunar'

export default {
  name: "sakura-vip",
  components: {
    Header,
    Footer,
    Login,
    Os,
    Swiper
  },

  data() {
    return {
      headerConfig,
      gameName: "sakura",
      downloadUrl: "https://sakura.qingcijoy.com/official/index.html",
      mySwiper: null,
      shareUrl: '',
      days: ['第一天', '第二天', '第三天', '第四天', '第五天', '第六天', '第七天'],
      sign_day: 0,
      sigin_status: false,
      loginTypes: ["sms", "password"],
      isShowRules: false, // 活动规则弹窗
      showSignDetail: false, // 签到规则弹窗
      isShowAddress: false, // 登记信息弹窗
      showAllReward: false, // 所有签文弹窗
      focusTimer: null,
      name: '',
      phone: '',
      address: '',
      addressSuccess: false,
      sign_id: 1,
      isClick: false,
      opened: false,//是否在抽奖中
      tags: [0, 0, 0, 0, 0, 0], // 签文数量
      currentIndex: 0,
      showExchangeConfirm: false,
      tagsText: {
        1: '暴富签x1、桃花签x1、学业签x1、升职签x1',
        2: '暴富签x1、桃花签x1、学业签x1、升职签x1、健康签x1',
        3: '暴富签x1、桃花签x1、学业签x1、升职签x1、特别签x1',
      },
      showExchangeSuccess: false, // 兑换成功
      isPlay: false,
      currentRoleIndex: 0, // 当前是第几个卡池
      currentRoles1Index: 0, // 第一个卡池的下标
      currentRoles2Index: 0, // 第二个卡池的下标
      showNoSigns: false, // 签文不足
      showGetSuccess: false, // 一键领取成功
      showShare: false,
      shareLink: '',
      showDrawResult: false, // 抽签结果
      showBreakDraw: false,
      preventShow: false,
      reward_id: 1, // 1:暴富，2：桃花，3学业，4升职，5健康，6特别，7游戏道具
      reward_name: '',
      flip: 'font',
      titleShow: false,
      showVideo: false,
      showWechat: false,
      oldYear: '',
      newYear: '',
      showGameStaff: false, // 抽中游戏道具奖励
      saveShow: false,
      shareImg: null,
      shareText: '',
      shareTexts: [
        '摇一摇，摇出新年幸运签~点击链接为我助力开启新年运势：',
        '《魔卡少女樱》x《喜羊羊与灰太狼》梦幻联动！我的童年又回来辣！详情戳→',
        '我怕元宵的鞭炮太响，你会忘记《魔卡少女樱》x《喜羊羊》联动版本送超、多、福、利！详情戳→'
      ],
      last_update: 0,
      last_x: 0,
      last_y: 0,
      last_z: 0,
      x: 0,
      y: 0,
      z: 0,
      iosIsAuth: false,
      showAuth: false,
      showNumber2: false,
      showTime: '2024-03-04 12:00:00', // 卡池第二期可点击时间
      showShakeTip: false,
      shakeCount: 0,
      currentSwiperIndex: 0,
      showInWechat: false,
      showKefuCode: true,
      isWeChat: false,
      isIos: false,
      isHarmony: false, // 是否鸿蒙浏览器打开

      // 游戏传过来的参数↓
      game_id: "",
      role_id: "",
      sign: "",
      token: "",
      server_id: "",
      // 游戏传过来的参数↑
      isSubmit: false // 通过提交接口的
    };
  },
  created() {
    if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) window.location.href = `https://h5.qingcigame.com/sakura/sheep/pc${getRandomString()}`
    const routerParams = analysisParams(window.location.href)
    if (routerParams.help_id) {
      const code = window.localStorage.getItem('sheepCode')
      if (code) {
        const code_arr = [...new Set(code.split(","))]
        // 第一次帮这个id助力
        if (!code.includes(routerParams.help_id)) {
          onHelp({ id: routerParams.help_id }).then((res) => {
            if (res.code === 200) {
              this.onToast('助力成功')
              code_arr.push(routerParams.help_id)
              window.localStorage.setItem('sheepCode', code_arr.join(','))
            } else {
              this.onToast(res.message)
            }
          })
        } else {
          // this.onToast('您已经给TA助力过啦~')
        }
      } else {//第一次帮别人助力
        onHelp({ id: routerParams.help_id }).then((res) => {
          if (res.code === 200) {
            this.onToast('助力成功!')
            window.localStorage.setItem('sheepCode', routerParams.help_id)
          } else {
            this.onToast(res.message)
          }
        })
      }
    }

    // 埋点
    const bl = buriedLogger("sakura", "小樱_喜羊羊联动");
    this.logger = bl;
    const { protocol, host } = window.location
    this.setShare({
      title: '《魔卡少女樱》x《喜羊羊》联动活动开启',
      desc: '点击参与羊羊元宵摇摇签，摇出新年运势~',
      imgUrl: 'https://download4.qcplay.com/qcgame-admin/1m4LK92efpVClQwIbQ8paKpFULuohnkg1Q54b1MI.png',
      link: `${protocol}//${host}/sakura/sheep/enter${getRandomString()}`,
    });
    const index = Math.floor(Math.random() * 3)
    this.shareText = this.shareTexts[index]
    this.showNumber2 = (new Date(this.showTime)).getTime() <= (new Date()).getTime()
    this.isWeChat = wechatBrowser()
    this.isIos = navigator.userAgent.match(/(iPhone|iPod|ios)/i)
    this.isHarmony = !this.isWeChat && navigator.userAgent.match(/(Harmony)/i)
  },
  mounted() {
    setTimeout(() => {
      // 清空store上的用户数据
      this.setInitActiveInfo()
      this.setInitUserInfo()
      this.titleShow = true
      this.initShakeDraw()
      this.indexSwiper()
      this.initPlayWaySwiper()
      this.initGameSwiper()
      this.initRolesSwiper()
      this.initRoles1Swiper()
      if (
        this.$route.query.game_id &&
        this.$route.query.role_id &&
        this.$route.query.token
      ) {
        this.game_id = this.$route.query.game_id;
        this.role_id = this.$route.query.role_id;
        this.sign = this.$route.query.sign;
        this.token = this.$route.query.token;
        this.server_id = this.$route.query.server_id;
        this.secretFreeLogin();
      } else {
        this.initData();
      }
    }, 200);
  },
  beforeDestroy() {
    window.removeEventListener('devicemotion', this.devicemotion, false)
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.sign_day = 0
          this.sigin_status = false
          this.sign_id = 1
          this.tags = [0, 0, 0, 0, 0, 0]
          this.currentIndex = 0
          this.reward_id = 1
          this.reward_name = ''
          this.flip = 'font'
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
        }
      }
    }
  },
  methods: {
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        game_id: this.game_id,
        role_id: this.role_id,
        sign: this.sign,
        token: this.token,
        server_id: this.server_id
      };
      secretFreeLoginApi(params).then(response => {
        if (response.code == 200) {
          this.logUpload("免密登录成功");
          const { protocol, host } = window.location;
          window.location.href = `${protocol}//${host}/sakura/sheep/enter${getRandomString()}`
        } else {
          this.logUpload("免密登录失败");
          this.onToast(response.message);
        }
      });
    },
    logUpload(string) {
      this.logger.sum(`小樱_喜羊羊联动_${string}`);
    },
    handleEnterWeibo() {
      this.logUpload('进入微博转发活动')
      setTimeout(() => {
        window.location.href = 'https://weibo.com/7189304322/O0QkM9mMy'
      }, 300)
    },
    handleChangeKefu() {
      this.showKefuCode = !this.showKefuCode
    },
    handleDownloadClick() {
      const isWechatBrowser = wechatBrowser()
      this.logUpload('下载游戏点击')
      if (isWechatBrowser) {
        return this.showInWechat = true
      }
      if (navigator.userAgent.match(/(iPhone|iPod|ios)/i)) {
        window.location.href = 'https://apps.apple.com/cn/app/id6450409747'
      } else {
        window.location.href = 'https://download4.qcplay.com/apk-v2/qc-kol-1131746.apk'
        // if ((new Date('2024-02-19 15:00:00')).getTime() <= (new Date()).getTime()) {
        //   window.location.href = 'https://download4.qcplay.com/apk-v2/qc-kol-1146316.apk'
        // } else {
        //   window.location.href = 'https://download4.qcplay.com/apk-v2/qc-kol-1131746.apk'
        // }
      }
    },
    getAuth() {
      window.DeviceMotionEvent.requestPermission().then((state) => {
        if (state === "granted") {
          // 监听传感器运动事件
          this.iosIsAuth = true
          this.showAuth = false;
          if (window.DeviceMotionEvent) {
            window.addEventListener("devicemotion", this.devicemotion, false);
          } else {
            this.onToast("手机不支持陀螺仪功能哦");
          }
        } else if (state === "denied") {
          this.onToast("您已拒绝授权,要使用晃动手机摇签的功能请去设置里清除相关授权数据");
        } else {
          this.showAuth = true
        }
      }).catch((err) => console.log('err', err))
    },
    initShakeDraw() {
      const system = navigator.userAgent.toLowerCase();
      if (system.indexOf("like mac os x") > 0) {
        // 苹果机
        const reg = /os [\d._]*/gi;
        const info = system.match(reg);
        const version = (info + "")
          .replace(/[^0-9|_.]/gi, "")
          .replace(/_/gi, ".");
        const list = version.split(".");
        // 苹果13手机 list[0]  16 list[1] 0
        // 对苹果13以后的版本处理
        if (list[0] > 15) {
          if (
            typeof DeviceMotionEvent !== "undefined" &&
            typeof DeviceMotionEvent.requestPermission === "function"
          ) {
            window.DeviceMotionEvent.requestPermission().then((state) => {
              console.log('授权', state)
              if (state === "granted") {
                // 监听传感器运动事件
                if (window.DeviceMotionEvent) {
                  window.addEventListener("devicemotion", this.devicemotion, false);
                } else {
                  this.onToast("手机不支持陀螺仪功能哦");
                }
              } else if (state === "denied") {
                // this.onToast("您已拒绝授权网页获取手机晃动权限哦");
              } else {
                this.showAuth = true
              }
            }).catch((err) => {
              console.log('err', err)
              if (err && err.name === 'NotAllowedError') {
                this.showAuth = true
              }
            })
            // this.getAuth()
          } else if (window.DeviceMotionEvent) {
            //监听设备运动
            window.addEventListener("devicemotion", this.devicemotion, false);
          }
        } else {
          console.log('ios13以下')
          if (window.DeviceMotionEvent) {
            //监听设备运动
            window.addEventListener("devicemotion", this.devicemotion, false);
          }
        }
      } else {
        console.log('安卓')
        //判断设否授权了 设备运动权限
        if (window.DeviceMotionEvent) {
          //监听设备运动
          window.addEventListener("devicemotion", this.devicemotion, false);
        }
      }
    },
    devicemotion(eventData) {
      if (this.currentSwiperIndex !== 1) return // 不在第二页不用触发
      if (this.isClick) {
        return false
      }
      const SHAKE_THRESHOLD = 800;
      // eventData.stopPropagation();
      // eventData.preventDefault();
      const acceleration = eventData.accelerationIncludingGravity;
      const curTime = (new Date()).getTime();
      if ((curTime - this.last_update) > 300 && (curTime - this.last_update) < 3000) {
        const diffTime = curTime - this.last_update;
        this.last_update = curTime;
        this.x = acceleration.x;
        this.y = acceleration.y;
        this.z = acceleration.z;
        const speed = Math.sqrt((this.x - this.last_x) * (this.x - this.last_x) + (this.y - this.last_y) * (this.y - this.last_y) + (this.z - this.last_y) * (this.z - this.last_y)) / diffTime * 10000;
        if (speed > SHAKE_THRESHOLD) {
          this.shakeCount++
          if (this.shakeCount > 1) {
            if (this.showBreakDraw) {
              return this.onToast('请先解签')
            }
            this.handleCloseDrawResult()
            this.handleCloseShakeTip()
            this.showGameStaff = false
            this.logUpload('使用手机晃动抽签')
            this.draw()
          }
        }
        this.last_x = this.x;
        this.last_y = this.y;
        this.last_z = this.z;
      }
      if ((curTime - this.last_update) > 3000) {
        this.shakeCount = 0
        this.last_update = curTime;
      }
    },
    handleShareFriend() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      this.logUpload("邀请按钮点击");
      this.showShare = true
    },
    handleCloseDrawResult() {
      this.showDrawResult = false
      this.shareImg = null
    },
    handleCloseSaveModal() {
      this.saveShow = false
    },
    generateShareImage() {
      Indicator.open()
      this.preventShow = true
      this.logUpload('分享截图')
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.preventShow = false;
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
          this.saveShow = true
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();
          console.log('err: 图片生成失败', err.message);
          this.onToast('生成图片失败！')
        });
    },
    handleShareClick() {
      if (this.shareImg) {
        return this.saveShow = true
      }
      try {
        this.generateShareImage()
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 一键领取道具奖励
    handleGetAll() {
      this.logUpload('一键领取按钮点击')
      onGetReward().then((res) => {
        if (res.code === 200) {
          // this.onToast('领取成功')
          this.showGetSuccess = true
          this.initData()
        } else {
          this.onToast(res.message)
        }
      })
    },
    // 翻页
    handleFlip(direction) {
      // direction为back时表示翻后面
      this.flip = direction
    },
    // 关闭视频
    handleCloseVideo() {
      const video = document.querySelectorAll('video')[0];
      video.pause()
      this.showVideo = false
    },
    // 播放视频
    handleVideoPlay() {
      this.showVideo = true
      const video = document.querySelectorAll('video')[0];
      video.currentTime = 0
      video.play();
      this.logUpload("视频播放");
      this.isPlay = true
    },
    // 解签
    handleBreakDraw() {
      if (this.reward_id === 7) {
        this.showGameStaff = true
      } else {
        this.showDrawResult = true
      }
      this.showBreakDraw = false
    },
    // 复制邀请链接
    onCopy(domName) {
      const clipboard = new Clipboard(domName)
      this.logUpload("复制邀请链接按钮点击");
      clipboard.on("success", e => {
        this.onToast("复制成功");
        e.clearSelection();
      });

      clipboard.on("error", e => {
        this.onToast("复制失败");
      });
    },
    handleChangeRole(index) {
      if (index === 1 && !this.showNumber2) {
        this.logUpload('期待缤纷草原卡池点击')
        return this.onToast("缤纷草原卡池将于3月4日中午12点后可浏览！")
      }
      this.currentRoleIndex = index
    },
    pauseVideo() {
      const video = document.querySelectorAll('video')[0];
      if (this.isPlay) {
        video.pause()
      } else {
        video.play();
      }
      this.isPlay = !this.isPlay;
    },
    // 填写地址
    handleWriteAddress() {
      this.isShowAddress = true
    },
    // 兑换奖励
    handleExchange(id) {
      const { num = 0, combination = [] } = this.activeInfo.exchange_list.filter((i) => i.id === id)[0] || {}
      const hasTagsLength = combination.map((i, index) => this.tags[i - 1]).filter((j) => j).length
      if (hasTagsLength < combination.length) {
        return this.showNoSigns = true
      }
      if (num <= 0 && id !== 1) return this.onToast('奖励数量不足无法兑换')
      this.sign_id = id
      this.showExchangeConfirm = true
    },
    handleExchangeConfirm() {
      const id = this.sign_id
      if (id === 1) {
        onGetRewardOnBag({ sign_id: id }).then((res) => {
          if (res.code === 200) {
            this.showExchangeConfirm = false
            this.showExchangeSuccess = true
            this.initData()
          } else {
            this.onToast(res.message)
          }
        })
      } else {
        onGetRewardOnBag({ sign_id: id }).then((res) => {
          if (res.code === 200) {
            this.showExchangeConfirm = false
            this.isShowAddress = true
            this.sign_id = ''
            this.initData()
          } else {
            this.onToast(res.message)
          }
        })
      }
    },
    handleShowAllReward() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      this.logUpload("集签兑换按钮点击");
      this.showAllReward = true
    },
    handleSignRuleDetail() {
      this.showSignDetail = true
    },
    handleSign() {
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      }
      onSign().then((res) => {
        if (res.code === 200) {
          this.onToast('今日签到成功')
          this.initData()
        } else {
          this.onToast(res.message)
        }
      })
    },
    // 分享按钮
    shareClick(e) {
      // const isWechatBrowser = wechatBrowser()
      // if (!isWechatBrowser) {
      //   return this.showNotInWechat = true
      // }
      switch (e) {
        case 1:
          // 微博
          this.logUpload("微博按钮点击");
          window.location.href = 'https://weibo.com/u/7189304322'
          break;
        case 2:
          // 微信
          this.logUpload("微信按钮点击");
          this.showWechat = true
          break;
        case 3:
          // tap
          this.logUpload("tap按钮点击");
          window.location.href = 'https://www.taptap.cn/app/378363'
          break;
        case 4:
          // 抖音
          this.logUpload("抖音按钮点击");
          window.location.href = 'https://v.douyin.com/iLQkWS7a/ 5@1.com'
          break;
        default:
          break;
      }
    },
    // 轮播切换
    goNextSwiper(e) {
      if (e === 1) {
        this.logUpload("开启摇签按钮点击");
      }
      this.mySwiper.slideTo(e, 300, true);
      this.showGuide = false
    },
    handleCloseShakeTip() {
      this.showShakeTip = false
      localStorage.setItem('sheepShowTip', 'clicked')
    },
    indexSwiper() {
      const that = this
      this.mySwiper = new Swiper('.content-swiper-container.swiper-container', {
        effect: 'slide',
        direction: 'vertical',
        slidesPerView: 'auto',
        paginationClickable: false,
        spaceBetween: 0,
        mousewheelControl: true,
        resistanceRatio: 0,
        noSwipingClass: 'play-way-swiper-container',
        initialSlide: 0,
        allowSwipeToNext: true,
        onSlideChangeEnd: function (swiper) {
          that.currentSwiperIndex = swiper.activeIndex
          const sheepShowTip = localStorage.getItem('sheepShowTip')
          if (swiper.activeIndex === 1 && !sheepShowTip) {
            that.showShakeTip = true
          }
        }
      });
    },

    initPlayWaySwiper() {
      new Swiper('.play-way-swiper-container.swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1,
        initialSlide: 0,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        pagination: '.play-way-pagination.swiper-pagination',
        // observer: true,
        // observeParents: true,
      })
    },

    initGameSwiper() {
      new Swiper('.game-swiper-container.swiper-container', {
        direction: 'horizontal',
        slidesPerView: "auto",
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        autoplay: 2000,
        pagination: '.game-pagination.swiper-pagination',
        nextButton: '.game-button-next.swiper-button-next',
        prevButton: '.game-button-prev.swiper-button-prev',
        // observer: true,
        // observeParents: true,
        effect: 'coverflow',
        coverflow: {
          rotate: 5,
          stretch: 27,
          depth: 30,
          modifier: 6,
          slideShadows: false
        },
        paginationBulletRender: function (swiper, index, className) {
          return '<div class="swiper-pagination-bullet ' + className + index + '">' + '</div>';
        }
      })
    },

    initRolesSwiper() {
      const that = this
      new Swiper('.roles-swiper-container.swiper-container', {
        slidesPerView: 5,
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        // observer: true,
        // observeParents: true,
        slideToClickedSlide: true,
        onlyExternal: true,
        // nextButton: '.roles-button-next.swiper-button-next',
        // prevButton: '.roles-button-prev.swiper-button-prev',
        onSlideChangeEnd: function (swiper) {
          if (swiper.activeIndex === 11) {
            swiper.slideTo(6, 0)
          }
          if (swiper.activeIndex === 12) {
            swiper.slideTo(7, 0)
          }
          if (swiper.activeIndex === 3) {
            swiper.slideTo(8, 0)
          }
          if (swiper.activeIndex === 4) {
            swiper.slideTo(9, 0)
          }
          that.currentRoles1Index = swiper.realIndex
        }
      })
    },
    initRoles1Swiper() {
      const that = this
      new Swiper('.roles-swiper-container1.swiper-container', {
        slidesPerView: 5,
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        // observer: true,
        // observeParents: true,
        slideToClickedSlide: true,
        onlyExternal: true,
        // nextButton: '.roles-button-next.swiper-button-next',
        // prevButton: '.roles-button-prev.swiper-button-prev',
        onSlideChangeEnd: function (swiper) {
          if (swiper.activeIndex === 11) {
            swiper.slideTo(6, 0)
          }
          if (swiper.activeIndex === 12) {
            swiper.slideTo(7, 0)
          }
          if (swiper.activeIndex === 3) {
            swiper.slideTo(8, 0)
          }
          if (swiper.activeIndex === 4) {
            swiper.slideTo(9, 0)
          }
          that.currentRoles2Index = swiper.realIndex
        }
      })
    },

    // 初始化接口
    initData() {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });
        if (response.code === 200) {
          const { protocol, host } = window.location
          this.shareLink = `${protocol}//${host}/sakura/sheep/enter${getRandomString()}?help_id=${response.data.user_info.id}`
          this.sign_day = response.data.activity.sign_day ? Number(response.data.activity.sign_day) : 0
          this.sigin_status = response.data.activity.sigin_status
          this.tags = response.data.activity.prop_accumulate || [0, 0, 0, 0, 0, 0]
        }
      });
    },
    handleShowRuleDetail() {
      this.isShowRules = true
      this.logUpload("活动规则按钮点击");
    },
    // 提交信息接口请求
    submitInfo() {
      if (!this.name || !this.address || !this.phone) {
        return this.onToast('请将信息填写完整')
      }
      const params = {
        name: this.name,
        address: this.address,
        phone: this.phone,
      }
      onSubmitAddress(params).then(response => {
        if (response.code == 200) {
          this.addressSuccess = true
          this.isShowAddress = false
          this.initData()
          // onGetRewardOnBag({ sign_id: this.sign_id }).then((res) => {
          //   if (res.code === 200) {
          //     this.addressSuccess = true
          //     this.isShowAddress = false
          //     this.sign_id = ''
          //     this.initData()
          //   } else {
          //     this.onToast(res.message);
          //   }
          // })
          // this.logger.sum("小樱_VIP专属客服_信息登记成功");
        } else {
          // this.logger.sum("小樱_VIP专属客服_信息登记成功");
          this.onToast(response.message);
        }
      });
    },
    draw() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      if (this.activeInfo.times <= 0) {
        // this.noCount = true
        this.onToast('剩余次数不足！')
        return
      }
      if (this.isClick) {
        return false
      }
      this.logUpload("摇签按钮点击");
      this.flip = 'font'
      this.isClick = true
      this.preventShow = true
      onDraw().then((res) => {
        this.lotterying = true
        this.opened = true
        this.shakeCount = 0
        if (Number(res.code) === 200) {
          this.initData()
          this.reward_id = res.data.reward_id
          if (res.data.reward_id === 7) {
            this.reward_name = res.data.name
          }
          const today = new Date(); // 2024年1月1日
          const nongli = calendarFormatter.solar2lunar(today.getFullYear(), today.getMonth() + 1, today.getDate()) || {}
          console.log(nongli)
          const { gzYear, IMonthCn, IDayCn, cYear, cMonth, cDay } = nongli
          const formatMonth = cMonth > 9 ? cMonth : `0${cMonth}`
          const formatDay = cDay > 9 ? cDay : `0${cDay}`
          this.oldYear = `${gzYear}年 · 农历${IMonthCn}${IDayCn}`
          this.newYear = `${cYear}年${formatMonth}月${formatDay}日`
          setTimeout(() => {
            this.opened = false
            this.isClick = false
            this.lotterying = false
            this.preventShow = false
            this.showBreakDraw = true // 出现解签弹窗
            // setTimeout(() => {
            //   this.preventShow = false
            // }, 1000)
          }, 1800)
        } else {
          this.onToast(res.message)
          this.isClick = false
          this.opened = false
          this.preventShow = false
          this.lotterying = false
        }
      })
    },
    // 打开提交二次确认弹窗
    showDialog() {
      const re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      let result = re.test(this.phone);
      if (!this.phone) {
        return this.onToast("请输入您的手机号");
      } else if (!result) {
        return this.onToast("请输入正确的手机号");
      }
      this.isShowAddress = true;
    },
    // 关闭登记信息弹窗
    closeAddress() {
      this.isShowAddress = false;
    },
    // 选择角色后
    selectCallback() {
      this.sign_day = 0
      this.sigin_status = false
      this.sign_id = 1
      this.tags = [0, 0, 0, 0, 0, 0]
      this.currentIndex = 0
      this.reward_id = 1
      this.reward_name = ''
      this.flip = 'font'
      this.name = ''
      this.phone = ''
      this.address = ''
      this.initData();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    //input聚焦
    inputFocus() {
      if (this.focusTimer) {
        clearTimeout(this.focusTimer)
      }
    },
    //input失焦
    inputFocusOut() {
      this.focusTimer = setTimeout(() => {
        window.scrollTo(0, 0)
      }, 10)
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger",
      "setUserInfo",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/sakura/sheep/index/index.vue